var map = {
	"./empty.png": 8841,
	"./hacksaw.png": 625,
	"./hammer.png": 1271,
	"./saw.png": 7302,
	"./screwdriver.png": 1756,
	"./spanner.png": 5790,
	"./stapler.png": 9003,
	"./wrench.png": 4212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7351;